<template>
  <auth-layout>
    <p
      v-t="'mywb.auth.register-one-step-more'"
      class="finish-title"
    />
    <p
      v-t="'mywb.auth.register-verify-email'"
      class="finish-title my-32"
    />
    <template v-if="isTransferRedirection">
      <p
        v-t="'mywb.transfer.checkEmailHint'"
        class="hint"
        data-test-id="transferCheckEmailHint"
      />
      <p
        v-t="'mywb.transfer.reopenLinkHint'"
        class="hint mb-32"
        data-test-id="transferReopenLinkHint"
      />
    </template>

    <wb-link
      class="is-size-500 link"
      type="text"
      data-test-id="loginBtn"
      @click="router.push({ name: ROUTES.AUTH_LOGIN })"
    >
      <span class="is-size-300 wb-icons mr-8 has-text-primary-500">arrow_back</span>
      <span>{{ i18n.t('mywb.auth.login') }}</span>
    </wb-link>
  </auth-layout>
</template>

<script setup lang="ts">
import AuthLayout from '@/components/auth/AuthLayout.vue'
import { trackScreen } from '@/engine/metrics'
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from '@/hooks/useI18n.hook'
import ROUTES from '@/engine/router/routes'

const i18n = useI18n()
const router = useRouter()

const isTransferRedirection = (() => {
  try {
    return JSON.parse(localStorage.getItem('wb-redirection') ?? 'null')?.name === ROUTES.TRANSFER
  } catch {
    return false
  }
})()

onMounted(() => {
  trackScreen('terms')
})
</script>

<style lang="postcss" scoped>
.finish-title {
  text-align: center;
  font-size: 3rem;
  font-weight: 700;
}

.hint {
  text-align: center;
  font-size: 1.6rem;
}

.link {
  display: block;
  text-align: center;
}
</style>
